// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__lvlN9","dark":"BaseLayout_dark__CE6w-","light":"BaseLayout_light__AjxmQ"};